import variables from 'variables.module.scss';

export const Table = {
  headerBg: variables.whiteColor,
  headerColor: variables.greyColor,
  headerSplitColor: 'transparent',
};
